export default "https://storage.googleapis.com/prepweb-prod/dist/eeb347cabbd37c061467c55c0b708858.svg";